import React from 'react';
import { connect } from "react-redux";
import mapStateToProps from 'reducers/actions/stateToProps';
import mapDispatchToProps from 'reducers/actions/dispatchProps';
import Constants from 'components/utils/constants';
import LoadingOverlay from 'components/common/loadingOverlay';
import { withSnackbar } from 'notistack';
import {concat as _concat, cloneDeep as _cloneDeep} from 'lodash';
import NewAccount from './NewAccount';
import SharingManager from './SharingManager';
import { AccountHandler } from 'chits-data/dist';
import NewAccountChitInfo from './NewAccountChitInfo';
import moment from 'moment-timezone';
import { WebClientStore } from 'web-client-store';
import { withTranslation } from 'react-i18next';
let {Session} = WebClientStore;

let { SESSION_KEYS } = Constants;

class AccountInfo extends React.Component {

    constructor(props) {
        super(props);
        this._isMounted = false; // prevents -> Warning: Can't perform a React state update on an unmounted component
        this._accountHandler = new AccountHandler();
    }

    state = {
        open: {
            widgetYearlyTrends: false,
            widgetTranTypeSplits: false,
        },
        roles: {
            owner: false,
            admin: false,
            editor: false,
            viewer: false,
            any: false,
        },
        showAccountInfo: true,
        accountInfoReadOnly: true,
        showAccountChitInfo: true,
        accountChitInfoReadOnly: true,
        openOverlay: false,
        accountLineUp: [Constants.DEFAULT_ACCOUNT],
        selectedAccount: Constants.DEFAULT_ACCOUNT,
        accountReceipts: [],
        termStarted: false,
        displayAccountSchedule: false,
        enableAccountSchedule: false,
        displayAccountSummary: true,
        enableAccountStmtSummary: false
    };

    componentDidMount = () => {
        this.handleGetAccounts()
    };

    handlePreprocessor = (accounts, ac, roles, trans) => {
        let _termStarted = false;
        try {
            if(ac.chit_info.nextTerm && ac.chit_info.nextTerm > 0) _termStarted = true
        } catch (error) {
            //
        }
        this.setState({
            accountLineUp: accounts,
            selectedAccount: ac,
            accountReceipts: ac.receipts,
            roles,
            termStarted: _termStarted
        });
    }

    //TODO: Do not need to fetch all accounts; limit only to active account.
    handleGetAccounts = async (unset=false) => {
        let _accountLineup = [];
        let _roles = this.state.roles;
        let defaultAccount = Constants.DEFAULT_ACCOUNT;
        let requested = defaultAccount;
        // let retrieveFrom = Constants.URLs.ACCOUNTS;
        this.setState({ openOverlay: true });
        this._accountHandler.getAccountsCached(unset).then((accounts) => {
            // Display only ACTIVE accounts; sorted by type
            let _accounts = Constants.sortAccountsByType(accounts.filter(ac=>{
                let isValid = ac.type === "CHIT";
                // if (ac.type === "CHIT") {
                //     isValid = ac.chit_info && ac.chit_info.nextTerm && ac.chit_info.nextTerm > 0;
                // }
                return isValid
                // return ac.status==="ac" && isValid
            }));
            _accountLineup = _concat(defaultAccount, _accounts);
            let activeAccountId = Session.get(SESSION_KEYS.ACTIVE_ACCOUNT);
            if (activeAccountId !== undefined && activeAccountId !== '') {
                requested = accounts.filter((item) => {
                    if(this.props.caller && this.props.caller === "AccountInfo") {
                        return item._id === activeAccountId;
                    } else {
                        //Any page other than account info must be restricted to non-active accounts
                        return item._id === activeAccountId;
                        // return item._id === activeAccountId && item.status === 'ac';
                    }
                })[0];
            }
            // console.log('identified object by the supplied param is:' + JSON.stringify(requested));
            if (!requested) {
                requested = defaultAccount;
                this.props.enqueueSnackbar('Requested account is not accessible. Please chose a valid account.', {
                    variant: 'warning'
                });
            } else {
                if (requested && requested.hasOwnProperty('curr') && requested.curr !== '') {
                    Session.set(SESSION_KEYS.ACTIVE_ACCOUNT_CURR, requested.curr);
                }
                if (requested && requested.hasOwnProperty('type') && requested.type !== '') {
                    Session.set(SESSION_KEYS.ACTIVE_ACCOUNT_TYPE, requested.type);
                }
                _roles = Constants.extractRolesFromAccount(requested);
            }
            this.setState({
                openOverlay: false,
                roles: _roles,
                selectedAccount: requested,
                accounts: _accountLineup
            })
            return true
        }).then(()=>{
            this.props.setCurrentAccount(requested);
            this.props.changePageTitle(this.state.selectedAccount.name)
            this.handlePreprocessor(_accountLineup, requested, _roles);
        })
    }

    _force_reload_account = () => {
        return (
            this._accountHandler.getAccountCached(this.state.selectedAccount._id, true).then((ac)=>{
                this.setState({ selectedAccount: ac });
                // force-refresh transactions on next visit to transactions page
                Session.set(this.state.selectedAccount._id + '_req_ts', moment().format('YYYYMMDDhhmmss'));
                // window.location.reload();
            })
        )
    }

    renderActionInfoForm() {
        return (
            <NewAccount
                display={this.state.showAccountInfo}
                onCancel={() => {
                    this.setState({ /*showAccountInfo: false,*/ accountInfoReadOnly: true  });
                    window.location.reload();
                }}
                onSubmit={() => {
                    this.setState({ /*showAccountInfo: false, enabledUpdate: false*/accountInfoReadOnly: true });
                    this._force_reload_account();
                }}
                onEnableEdit={() => {
                    this.setState({ /*showAccountInfo: false,*/ accountInfoReadOnly: false });
                }}
                onBusy={(busy) => {
                    this.setState({ openOverlay: busy });
                }}
                onInitChitInfo={()=>{}}
                modeUpdate={true}
                asDialog={false}
                readOnly={this.state.accountInfoReadOnly}
                hideActions={!(this.state.roles.owner || this.state.roles.admin)}
                hideArchive={!this.state.roles.owner}
            />
        )
    }

    renderActionChitInfo() {
        return (
            <>
            {this.state.termStarted && <span
                style={{ margin: '2px 0px 1px 20px', color: '#e91e63'}}
            >Note: Chit has been started. No further edits possible.</span>}
                <NewAccountChitInfo
                    display={this.state.showAccountChitInfo}
                    onCancel={() => {
                        this.setState({ /*showAccountInfo: false,*/ accountChitInfoReadOnly: true });
                    }}
                    onSubmit={() => {
                        this.setState({ /*showAccountInfo: false, enabledUpdate: false*/accountChitInfoReadOnly: true });
                        this._force_reload_account();
                    }}
                    onEnableEdit={() => {
                        this.setState({ /*showAccountInfo: false,*/ accountChitInfoReadOnly: false });
                    }}
                    onBusy={(busy) => {
                        this.setState({ openOverlay: busy });
                    }}
                    modeUpdate={true}
                    asDialog={false}
                    readOnly={this.state.accountChitInfoReadOnly}
                    account={this.state.selectedAccount}
                    hideActions={!(this.state.roles.owner || this.state.roles.admin)}
                    hideArchive={!this.state.roles.owner}
                    termStarted={this.state.termStarted}
                />
            </>
        )
    }

    renderModalSharingManager() {
        return (
            <SharingManager
                display={true}
                selectedAccount={this.state.selectedAccount}
                roles={this.state.roles} />
        )
    }


    render() {
        let {
            wallet,
            t
        } = this.props;
        return (
            <div className="content-fluid">
                <div className="row" >
                    <div className={this.state.currentAction==="info" ? "col-md-9 mx-auto" : "col-md-9 mx-auto"}  >
                        <div className="card" >
                            <div className="card-header" 
                            style={{ paddingLeft: '1em', paddingRight: '1em', paddingTop: '1em', textAlign: 'center'}}
                            >
                                <h4 className="card-title">{t('Chitfund Information')}</h4>
                                <p className="card-category"
                                    style={{ color: '#9C27B0', fontWeight: '500' }}
                                >{wallet.current._id === "default" ? "" : wallet.current.name}</p>
                            </div>
                            <div className="card-body"
                            style={{ padding: '4px'}}
                            >
                                <div className="container">
                                    <ul className="nav nav-pills nav-tabs nav-fill" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link active" id="home-tab" data-bs-toggle="tab"
                                                data-bs-target="#home-tab-pane" type="button" role="tab" 
                                                aria-controls="home-tab-pane" aria-selected="true">{t('Information')}</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="profile-tab" data-bs-toggle="tab"
                                                data-bs-target="#profile-tab-pane" type="button" role="tab" 
                                                aria-controls="profile-tab-pane" aria-selected="false">{t('Chit Profile')}</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="sharing-tab" data-bs-toggle="tab"
                                                data-bs-target="#sharing-tab-pane" type="button" role="tab" 
                                                aria-controls="sharing-tab-pane" aria-selected="false">{t('Sharing')}</button>
                                        </li>
                                    </ul>
                                    <div className="tab-content" id="myTabContent">
                                        <div className="tab-pane fade show active" id="home-tab-pane" role="tabpanel" 
                                            aria-labelledby="home-tab" tabIndex="0">{this.renderActionInfoForm()}</div>
                                        <div className="tab-pane fade" id="profile-tab-pane" role="tabpanel" 
                                            aria-labelledby="profile-tab" tabIndex="0">{this.renderActionChitInfo()}</div>
                                        <div className="tab-pane fade" id="sharing-tab-pane" role="tabpanel" 
                                            aria-labelledby="sharing-tab" tabIndex="0">{this.renderModalSharingManager()}</div>
                                    </div>
                                </div>
                                {this.state.openOverlay && <LoadingOverlay />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(
    withTranslation()(
        AccountInfo
    )
));
